import { createFileRoute } from '@tanstack/react-router';

import { ScheduledReportsPage } from '@/features/nis2/pages/ScheduledReportsPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/scheduled')({
  component: ScheduledReportsRoute,
});

function ScheduledReportsRoute() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ScheduledReportsPage />
      </div>
    </div>
  );
}
